module.exports = __webpack_public_path__ + "img/181.195bedf7.jpg";